import { z } from 'zod';

export const formSchema = z.object({
  ngay_hl: z.string(),
  sl_tu: z.union([z.number(), z.string()]).default(0).nullable().optional(),
  gia_nt: z.union([z.number(), z.string()]).default(0),
  status: z.number().default(1)
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  ngay_hl: new Date().toISOString().split('T')[0],
  sl_tu: 0,
  gia_nt: 0,
  status: 1
};
